import React from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { Avatar } from '@wartek-id/avatar'
import { Icon } from '@wartek-id/icon-v2'

import { useMediaQueryHelper } from 'app/RuangGTKHomepageV3/hooks/useMediaQueryHelper'
import { BottomNav } from 'components/BottomNav'
import { useAuth } from 'utils/auth'
import { useSETrackEvent } from 'app/Homepage/hooks/useSETrackEvent'
import { setInformationPageNavigationOrigin } from 'app/InfoTerkiniPage/utils/navigationOrigin'
import {
  useContentSearchOnboarding,
  useContentSearchTracker,
} from 'stores/content-search'

import type { NavItem } from 'components/BottomNav'

const ConfigIconWithAvatar = () => {
  const { session } = useAuth()
  const { asPath } = useRouter()

  return (
    <Avatar
      src={session?.user.picture}
      name={session?.user.name}
      size="sm"
      alt="Avatar"
      className={clsx(
        '!w-[24px] !h-[24px] border',
        asPath === '/akun' ? 'border-[#4C8DF6]' : 'border-[#808489]'
      )}
    />
  )
}

const NavigationBar = () => {
  const { isDesktop } = useMediaQueryHelper()
  const { SETrackClickBottomNavbar } = useSETrackEvent()
  const router = useRouter()
  const contentSearchOnboardingStore = useContentSearchOnboarding()
  const contentSearchTrackerStore = useContentSearchTracker()

  const navItems: NavItem[] = React.useMemo(
    () => [
      {
        href: '/home',
        icon: ({ className }: { className?: string }) => (
          <Icon className={clsx(className, '!block')} height={24} width={24}>
            home
          </Icon>
        ),
        text: 'Beranda',
      },
      {
        href: '/pencarian',
        icon: ({ className }: { className?: string }) => (
          <Icon className={clsx(className, '!block')} height={24} width={24}>
            search
          </Icon>
        ),
        text: 'Cari',
      },
      {
        href: '/info-terkini',
        icon: ({ className }: { className?: string }) => (
          <Icon className={clsx(className, '!block')} height={24} width={24}>
            notifications_outlined
          </Icon>
        ),
        text: 'Pemberitahuan',
      },
      {
        href: '/akun',
        text: 'Akun',
        icon: ConfigIconWithAvatar,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const onNavigate = (href: string): void => {
    const paths = {
      '/home': 'CLICK_NAVBAR_HOMEPAGE',
      '/ide-praktik': 'CLICK_NAVBAR_IDE_PRAKTIK',
      '/learning-group': 'CLICK_NAVBAR_CLASS',
      '/pencarian': 'CLICK_NAVBAR_SEARCH_PAGE',
      '/akun': 'CLICK_PROFILE_PICTURE_TAB',
      '/info-terkini': 'CLICK_NAVBAR_INFORMATION_PAGE',
    }

    if (paths[href]) {
      SETrackClickBottomNavbar(paths[href])
    }

    if (href === '/info-terkini') {
      setInformationPageNavigationOrigin(router.route ?? router.pathname)
    }

    if (href === '/pencarian') {
      contentSearchTrackerStore.setSource('NAVBAR_SEARCH_PAGE')

      if (!contentSearchOnboardingStore.isFinished) {
        contentSearchOnboardingStore.setFinished()
      }
    }
  }

  if (isDesktop) return null

  return (
    <BottomNav
      isRuangGtkEnabled
      navItems={navItems}
      data-testid="home-navigation-bar"
      onNavigate={onNavigate}
      className="!max-w-full"
    />
  )
}

export default NavigationBar
